<template>
    <div class="pin-modal" @mousedown="$emit('clear')">
        <div class="pin-modal-scroll">
            <Settings :settings="settings" v-if="settings" @close="settings = null" />
            <div class="pins-wrap">
                <Pin :pin="pin" @setSettings="setSettings" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ModalPin',
    data () {
        return {
            settings: null
        }
    },
    props: {
        pin: {
            type: Object,
            require: true
        }
    },
    components: {
        Pin: () => import('./Pin'),
        Settings: () => import('@/components/Modals/Settings')
    },
    methods: {
        setSettings(pin) {
            this.settings = pin
        }
    }
}
</script>
<style lang="stylus" scoped>
.pin-modal
    position fixed
    left 0
    top 0
    right 0
    bottom 0
    z-index 4
    background-color rgba(0,0,0,0.5)
    overflow-y auto
    &-scroll
        display flex
        justify-content center
        width 100%
        padding 20px 0
        +to-width(540px)
            padding-bottom 100px
    .pin
        border none
</style>